var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { memo } from "react";
const SvgClassTitan = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32",
  fill: "currentColor"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M14.839 15.979 1.661 8.37v15.218zm2.322 0 13.178 7.609V8.37zm5.485-12.175L16.057 0 2.879 7.609l13.178 7.609 13.179-7.609zm0 16.784-6.589-3.805-13.178 7.609L16.057 32l13.179-7.608-6.59-3.805z"
})));
const Memo = /*#__PURE__*/memo(SvgClassTitan);
export default Memo;